<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.999 1.89746C12.5145 1.8975 13.0215 2.03029 13.4707 2.2832C13.8637 2.50446
       14.2007 2.81131 14.458 3.17969L14.5635 3.3418L14.5664 3.34668L23.0371 17.4863L23.0449
       17.5C23.3069 17.9536 23.4458 18.4684 23.4473 18.9922C23.4487 19.5159 23.3121 20.0313
       23.0527 20.4863C22.7933 20.9412 22.4191 21.3204 21.9678 21.5859C21.5164 21.8515
       21.0032 21.9942 20.4795 22H3.51758C2.99385 21.9942 2.4807 21.8516 2.0293
       21.5859C1.57793 21.3203 1.20372 20.9413 0.944336 20.4863C0.684976 20.0313
       0.549361 19.5159 0.550781 18.9922C0.552248 18.4684 0.691177 17.9536 0.953125
       17.5C0.95575 17.4955 0.958241 17.4908 0.960938 17.4863L9.43066 3.34668L9.43359
       3.3418C9.701 2.90096 10.0781 2.53616 10.5273 2.2832C10.9766 2.03036 11.4835
       1.89746 11.999 1.89746ZM11.999 16C11.4467 16 10.999 16.4477 10.999 17C10.999
       17.5523 11.4467 18 11.999 18H12.0088C12.5611 18 13.0088 17.5523 13.0088 17C13.0088 16.4477
       12.5611 16 12.0088 16H11.999ZM11.999 8C11.4467 8.00001 10.999 8.44772 10.999 9V13C10.999
       13.5523 11.4467 14 11.999 14C12.5513 14 12.999 13.5523 12.999 13V9C12.999 8.44772 12.5513 8 11.999 8Z"
      fill="#FF9067"
    />
  </svg>
</template>